import React from 'react';
import OutputReportAdmin from './OutputReportAdmin';

const OutputReportsForUser = ({ api, partyId }) => {
    if (!partyId) {
        return (
            <div style={{ padding: '20px', color: 'red' }}>
                Error: Unable to determine user ID. Please reload the page.
            </div>
        );
    }

    const criteria = { RecipientPartyId: parseInt(partyId, 10) };

    return (
        <div>
            <OutputReportAdmin api={api} initialCriteria={criteria} />
        </div>
    );
};

export default OutputReportsForUser;
